import React from "react";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const EProductsPage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br px-6">
            {/* Icon */}
            <div className="bg-white p-6 rounded-full shadow-md mb-6">
                <HourglassEmptyIcon className="text-blue-500" sx={{ fontSize: 60 }} />
            </div>

            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
                eProducts
            </h1>

            {/* Subtitle */}
            <p className="text-gray-600 text-center max-w-md mb-8">
                Once we upload our products, you will be the first to know.
            </p>
        </div>
    );
};

export default EProductsPage;
